import React from 'react';

import { Flex, Typography } from 'antd';

import { AuditOutlined } from '@ant-design/icons';

type Props = { clientName: Client.Model['name'] };

export function SignUpInviteTitle({ clientName }: Props) {
    return (
        <Flex
            data-component="SignUpInviteTitle" 
            justify="flex-start"
            gap="middle" 
            style={{ paddingBlock: 'var(--ant-padding-sm)'}}
        >
            <AuditOutlined style={{ fontSize: 'var(--ant-font-size-heading-1)' }} />

            <Flex vertical>
                <Typography.Title
                    level={1}
                    style={{ margin: 0, fontSize: 'var(--ant-font-size-heading-4)' }}
                >
                    {clientName}
                </Typography.Title>

                <Typography.Paragraph style={{ margin: 0, fontWeight: 500 }}>
                    Controle de acesso para visitantes
                </Typography.Paragraph>
            </Flex>
        </Flex>
    );
}
